const eq = str => value => value === str;

export default eq;
